module.exports = "/packs/013-8ca5e15f6487067488ef077f72a698e1.svg";